export enum OnboardingUserType {
  distributor = "distributor",
  retailer = "retailer",
}

export interface OnboardingSessionType {
  session_id: string;
  onboarding_user_type?: OnboardingUserType;
}
